import React, {Component} from 'react';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import {UncontrolledPopover, PopoverHeader, PopoverBody} from 'reactstrap';
import AnimateHeight from 'react-animate-height';
import {StickyContainer, Sticky} from 'react-sticky'

import SlideEnterLockHeader from './SlideEnterLockHeader';
import SlideEnterLock, {LabelType} from './SlideEnterLock';
import ScoreSetsHeader from './ScoreSetsHeader';

import FilterableProviderList from './FilterableProviderList';

import ModalComponent from '../../../../components/modal/ModalComponent';

import notificationService from '../../../../components/Notifications/notificationService';
import Alert from '../../../../components/Notifications/Alert';
import Notification from '../../../../components/Notifications/Notification';
import NotificationManager from '../../../../components/Notifications/NotificationManager';

import providerUtils from './utils/providerUtils';
import uiUtils from './utils/uiUtils';

import {withInjector} from "../../../angularReactRedux/InjectorProvider";
import {ScorePreviewSection} from "./ScorePreviewSection";
import {SaveCancelToolbar} from "./SaveCancelToolbar";

const updateScoreSetForBrandRestrictions = (brandRestrictions, accountIds, components, viewState) => {
  if(!accountIds.length) accountIds = Object.keys(brandRestrictions)
  const zeroOut = (component, componentSiblings, viewState) => {
    if(component){
      const notSelfFilter = f => f !== component;
      if(!uiUtils.isEnabled(brandRestrictions, accountIds, component.id)) {
        uiUtils.distributeWeightedOptions(component, componentSiblings, 0, notSelfFilter);
        viewState.isOpened = false;
      }
    }
    if(component.components && component.components.length){
      component.components.forEach((childComponent, i) => zeroOut(childComponent, component.components, viewState[i] || []))
    }
  };
  components.forEach((component, i) => zeroOut(component, components, viewState[i]));
};

class SocialScoreSettings extends Component{
  constructor(props){
    super(props);
    this.state = {
      scoreSets: undefined,
      selectedScoreSetIndex: 0,
      watchLocationHash: true,
      isEditing: false
    };

    this.scoreSetActionsBridge = props.$injector.get('scoreSetActions')

    //TODO - update Babel to use new stage so can define lexical functions
    this.drawTopLevelSliders = this.drawTopLevelSliders.bind(this);
    this.onExpandAll = this.onExpandAll.bind(this);
    this.onResetSettings = this.onResetSettings.bind(this);
    this.onResetSettings = this.onResetSettings.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
    this.onSelectedScoreSetChange = this.onSelectedScoreSetChange.bind(this);
    this.onCreateScoreSet = this.onCreateScoreSet.bind(this);
    this.onCreatedScoreSet = this.onCreatedScoreSet.bind(this);
    this.onEditScoreSet = this.onEditScoreSet.bind(this);
    this.onEditedScoreSet = this.onEditedScoreSet.bind(this);
    this.onDeleteScoreSet = this.onDeleteScoreSet.bind(this);
    this.onLocationChangeStart = this.onLocationChangeStart.bind(this);
  }

  componentDidMount(){
    const { $injector } = this.props;
    this.$transitions = $injector.get('$transitions');
    this.$stateService = $injector.get('$state');
    this.transitionFunction = this.onLocationChangeStart;
    this.$transitions.onStart({}, (transition) =>  this.transitionFunction && this.transitionFunction(transition));
    this.$transitions.onExit({}, () => { this.transitionFunction = null; });
  }


  componentWillReceiveProps(nextProps, nextState){
    // TODO this is buggy. Resets all state everytime the props changes. (causes weights flicker when saving)
    // Would be fixed better by moving editing state to redux
    if(nextProps.state && nextProps.state.settings && nextProps.state.settings.accounts) {
      let viewState = this.state.viewState;
      const {accounts, labels, locations, scoreSets, scoreSetsDefaults, verticals, providers, toolTips,  requesting, brandRestrictions} = nextProps.state.settings;
      const providersHash = {};
      providers.forEach(provider => providersHash[provider.id] = provider);



      let selectedScoreSetIndex = 0;
      if(this.state.scoreSets && this.state.scoreSets){
        if(this.state.scoreSets.length > scoreSets.length){
          selectedScoreSetIndex = 0;
        }else if(this.state.scoreSets.length < scoreSets.length){
          selectedScoreSetIndex = scoreSets.length - 1;
        }else {
          selectedScoreSetIndex = this.state.selectedScoreSetIndex;
        }
      }

      const scoreSet = scoreSets[selectedScoreSetIndex];
      viewState = uiUtils.buildViewState(scoreSet.scoreConfig.components, this.state.viewState);
      uiUtils.disableAccountRestricted(brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig);

      // this state and this component is getting a little crazy.
      // Could break it up if we lifted the score set state into redux
      // (current score set, original score set, list of score sets)
      // and plugged in components through connect methods.
      // some of the other state in here seems like it ought to just be static (the tooltips)
      this.setState({
        accounts,
        brandRestrictions,
        labels,
        locations,
        providers,
        providersHash,
        restoreSets: cloneDeep(scoreSets),
        requesting,
        scoreSets: scoreSets,
        scoreSetsDefaults,
        selectedScoreSetIndex,
        toolTips,
        verticals,
        viewState
      });
    }
  }
  onLocationChangeStart(trans){
    if(this.state.isEditing){
      notificationService.addAlert(
        <Alert
          title="Unsaved Changes"
          message={
            <React.Fragment><p className="mb-0">You are about to navigate to another section of the application.</p><p className="mb-0">Unsaved changes will be discarded.</p></React.Fragment>}
          success="Save"
          onSuccess={() => {
            const scoreSet = this.state.scoreSets[this.state.selectedScoreSetIndex];
            updateScoreSetForBrandRestrictions(this.state.brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig.components, this.state.viewState);
            this.scoreSetActionsBridge.updateScoreConfig(
              scoreSet
            ).then(scoreConfig => {
              this.onEditedScoreSet(scoreConfig);
              this.state.isEditing = false;
              this.$stateService.go(trans.$to());
            }).catch(ex => {
              this.onErrorSaving(scoreSet, 'saving', () => {
                this.onEditScoreSet(scoreSet);
              })
            });
          }}
          cancel="Discard"
          onCancel={() => {
            // this.$stateService.transitionTo(trans.to);
            this.state.isEditing = false;
            this.$stateService.go(trans.$to());
          }}
        />
      );
      return false;
    }
  }

  // draw logic
  drawTopLevelSliders(component, siblings, labels, toolTips, viewState){

    return (
      <div id={component.id.replace(/\./g, '-')} key={`weights-${component.id}`} className="section-settings mr-2">
        <SlideEnterLockHeader
          key={`header-${component.id}`}
          id={component.id}
          label={labels[component.id]}
          tooltip={toolTips[component.id]}
          value={component.weight}
          active={viewState.sliderActive}
          opened={viewState.isOpened}
          enabled={component.isEnabled}
          locked={component.isLocked}
          hasChildren={!!(component.components && component.components.length)}
          onBeforeChange={this.onSliderActivationChange.bind(this, viewState, true)}
          onAfterChange={this.onSliderActivationChange.bind(this, viewState, false)}
          onChange={this.onSliderChange.bind(this, component, siblings)}
          onToggleLocked={this.onLockClick.bind(this, component)}
          onToggleOpened={this.onToggleDisplay.bind(this, viewState)}
        />
        <AnimateHeight duration={500} height={viewState.isOpened ? 'auto' : 0}>
          <div key={`${component.id}-childContainer`} className="col-12 offset-sm-2 col-sm-10 border my-3 py-2 rounded"> {this.drawChildComponents(component, labels, toolTips, viewState)}</div>
        </AnimateHeight>
      </div>
    );

  }

  drawChildComponents(component, labels, toolTips, viewState){
    const children = component.components.map((childComponent, index) => {
      const typeCategory = uiUtils.idTypeCategory(childComponent.id);
      switch(typeCategory.type) {
        case 'providers':
          return this.drawProviders(childComponent, labels, toolTips, viewState.components[index]);
        default:
          return this.drawTopLevelSliders(childComponent, component.components, labels, toolTips, viewState.components[index])
      }
    });

    return children;
  }

  drawProviders(component, labels, toolTips, viewState){
    let displayChildren;

    const {providers, providersHash, scoreSets, selectedScoreSetIndex, verticals} = this.state;
    const onProviderSelect = this.onAddProviderSelect.bind(this, component.components, viewState);

    const filteredProviderByType = providerUtils.filteredProviders(
                                      uiUtils.idTypeCategory(component.id),
                                      providers,
                                      providersHash,
                                      scoreSets[selectedScoreSetIndex].verticalIds,
                                      verticals
                                    );
    displayChildren = [
      component.components.map((childComponent, index) => this.drawOptions(childComponent, component.components, providersHash[childComponent.id].name, LabelType.PROVIDER, index, -1, viewState.components[index]))
    ];

    const popover = (
      <UncontrolledPopover className="popover-custom providers" target={component.id} placement="top">
        <PopoverHeader>
          Providers
        </PopoverHeader>
        <PopoverBody>
          <FilterableProviderList
            providers={filteredProviderByType}
            fixed={this.props.state.settings.fixedProviders}
            selected={component.components}
            onSelect={onProviderSelect}
          />
        </PopoverBody>
      </UncontrolledPopover>
    );

    //do not display for listings
    if(filteredProviderByType && filteredProviderByType.length){
      displayChildren.push(
        <div key={`${component.id}-addProvider`} className="add-provider text-right mb-5">
          <button type="button" placement="top" id={component.id} className="btn btn-secondary">+ Add Provider</button>
        </div>
      )
    }

    if (!component.id) {
      console.warn("no id", component)
    }

    return [
      (<SlideEnterLockHeader
        id={component.id}
        key={component.id}
        label={labels[component.id]}
        tooltip={toolTips[component.id]}
        opened={viewState.isOpened}
        enabled={component.isEnabled}
        locked={component.isLocked}
        hasChildren={true}
        onToggleOpened={this.onToggleDisplay.bind(this, viewState)}
      />),
      (
        <AnimateHeight key={`${component.id}-animate-height`} duration={500} height={viewState.isOpened ? 'auto' : 0}>
          {displayChildren}
        </AnimateHeight>
      )
    ];
  }

  drawOptions(component, components, label, type, index, settingIndex, viewState){
    return (
      <SlideEnterLock
        key={`${component.id}-${index}-${settingIndex}`}
        label={label}
        type={type}
        id={component.id}
        value={component.weight}
        enabled={component.isEnabled}
        locked={component.isLocked}
        active={viewState.sliderActive}
        removable={providerUtils.isFixedProvider(component.id)}
        onChange={this.onSliderChange.bind(this, component, components)}
        onBeforeChange={this.onSliderActivationChange.bind(this, viewState, true)}
        onAfterChange={this.onSliderActivationChange.bind(this, viewState, false)}
        onToggleLocked={this.onLockClick.bind(this, component)}
        onRemove={this.onRemoveOption.bind(this, component, components)}
      />
    );
  }

  onSliderActivationChange(viewState, active){
    viewState.sliderActive = active;
    this.setState({ isEditing: true });
  }
  // controller logic
  onSliderChange(currentOption, options, e){
    if(currentOption.isLocked) return;
    options = options.filter(o => typeof o.weight !== 'undefined');
    const weight = typeof e === "object" ? e.target.value || 0 : e;
    const enabledAndLockFilter = f => f.isEnabled && !f.isLocked && f !== currentOption;
    uiUtils.distributeWeightedOptions(currentOption, options, weight, enabledAndLockFilter); // I mutate

    //state was directly mutated >;0, but just working on components now.... not the react/redux paradigm, updates the component
    this.setState({...this.state, isEditing: true });
  }

  onLockClick(property, e){
    property.isLocked = !property.isLocked;
    // see above
    this.setState(this.state);
  }

  onRemoveOption(option, options, e){
    options.splice(options.indexOf(option), 1);
    //distributes value to other options
    this.onSliderChange(option, options, { target: { value: 0 } });
    this.setState({...this.state, isEditing: true});
  }

  onToggleDisplay(obj){
    obj.isOpened = !obj.isOpened;
    //see above
    this.setState(this.state)
  }

  onExpandAll(state){
    const {viewState} = this.state;
    const open = obj => {
      if(obj.components && obj.components.length){
        obj.isOpened = state;
        obj.components.forEach(open)
      }
    };
    viewState.forEach(open);
    this.setState(this.state);
  }

  onResetSettings() {
    if(this.state.isEditing){
      notificationService.addAlert(
        <Alert
          title="Reset score template"
          message="Discard all edits?"
          success="Discard"
          onSuccess={() => this.resetSettings()}
          cancel="Cancel"
          onCancel={() => { /*DO NOTHING BUT CLOSE*/ }}
        />
      );
    }else{
      // no changes to revert
    }
  }
  resetSettings(){
    const {brandRestrictions, scoreSets, restoreSets, selectedScoreSetIndex} = this.state;
    const restore = cloneDeep(restoreSets[selectedScoreSetIndex]);
    uiUtils.disableAccountRestricted(brandRestrictions, restore.accountIds, restore.scoreConfig);
    scoreSets[selectedScoreSetIndex] = restore;
    this.setState({ isEditing: false });
  }

  onAddProviderSelect(components, viewState, selected){
    components.push({ id: selected.id, label: selected.name, weight: 0, isEnabled: true });
    viewState.components.push(uiUtils.newViewStateComponent());
    this.setState({...this.state, isEditing: true});
  }

  onSelectedScoreSetChange(i){
    const {selectedScoreSetIndex} = this.state;
    if(i === selectedScoreSetIndex) return;
    if(this.state.isEditing){
      const scoreSet = this.state.scoreSets[selectedScoreSetIndex];
      notificationService.addAlert(
        <Alert
          title="Unsaved Changes"
          message={`Unsaved changes to ${scoreSet.scoreConfig.name}  will be lost. Do you want to save before continuing?`}
          success="Save"
          onSuccess={() => this.saveAndNavigateToScoreSet(selectedScoreSetIndex, i)}
          cancel="Discard"
          onCancel={() => this.navigateToScoreSet(i)}
        />
      );
    }else{
      this.navigateToScoreSet(i)
    }
  }

  saveAndNavigateToScoreSet(currentIndex, nextIndex){
    // not idea to wait for save to occur before navigating away but will help if shit fails
    const scoreSet = this.state.scoreSets[currentIndex];
    updateScoreSetForBrandRestrictions(this.state.brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig.components, this.state.viewState);
    this.scoreSetActionsBridge.updateScoreConfig(scoreSet)
    .then((updated) => {
      this.onEditedScoreSet(updated);
      setTimeout(() => this.navigateToScoreSet(nextIndex), 0);
    }).catch(ex => {
      this.onErrorSaving(scoreSet, 'saving', () => {
        this.onEditScoreSet(scoreSet);
        this.onSelectedScoreSetChange(nextIndex);
      });
    });
  }


  navigateToScoreSet(i){
    const scoreSet = this.state.scoreSets[i];
    uiUtils.buildViewState(scoreSet.scoreConfig.components, this.state.viewState);
    uiUtils.disableAccountRestricted(this.state.brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig);
    this.setState({ selectedScoreSetIndex: i, isEditing: false });
  }

  onSaveClick(e){
    const {accounts, scoreSets, selectedScoreSetIndex,  verticals} = this.state;
    const selected = scoreSets[selectedScoreSetIndex];

    if(!selected.scoreConfig.isDefault){
      this.onEditScoreSet(selected)
    }else{
      notificationService.addAlert(
        <Alert
          title="Editing Defaults"
          message={`You are changing the recommended defaults for the score set "${selected.scoreConfig.name}". Are you sure you'd like to save these changes?`}
          success="Save"
          onSuccess={() => this.onCreateScoreSet(selected)}
          cancel="Cancel"
          onCancel={() => this.resetSettings()}
        />
      );
    }
    //this.setState({ isEditing: false });
  }

  onCreateScoreSet(scoreSet){
    updateScoreSetForBrandRestrictions(this.state.brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig.components, this.state.viewState);
    this.scoreSetActionsBridge.createScoreConfig(scoreSet, this.onErrorSaving(scoreSet, 'saving'))
      .then((scoreSets) => this.onCreatedScoreSet(scoreSets.find(ss=> ss.scoreConfig.name === scoreSet.scoreConfig.name)))
      .then(() => this.selecteScoreSetByName(scoreSet.scoreConfig.name))
      .catch(() => this.onErrorSaving(scoreSet, 'creating', () => this.onCreateScoreSet(scoreSet)));
    this.setState({ isEditing: false });
  }

  onCreatedScoreSet(scoreSet){
    if(!scoreSet){
      const notification = (<Notification
        text={`The given account configuration does not exist for any accounts, please retry cofiguration."`}
        type={Notification.Types.WARNING}
      />);
      notificationService.addPopup(notification);
      return;
    }

    const notification = (<Notification
        text={`Your new Scoring Set "${scoreSet.scoreConfig.name}" has successfully been created.`}
        type={Notification.Types.SUCCESS}

      />);
    notificationService.addPopup(notification);
    this.setState({isEditing: false});
  }

  //Should be loaded from server to verify integrity, but will give perceived load time
  // (or could have server error with latest if revision does not match.
  // Integrity verification isn't really something chatmeter does anywhere though)
  onEditScoreSet(scoreSet){
    updateScoreSetForBrandRestrictions(this.state.brandRestrictions, scoreSet.accountIds, scoreSet.scoreConfig.components, this.state.viewState);
    this.scoreSetActionsBridge
      .updateScoreConfig(scoreSet)
      .then(scoreSets => this.onEditedScoreSet(scoreSets.find(ss=> ss.scoreConfig.name === scoreSet.scoreConfig.name)))
      .then(() => this.selecteScoreSetByName(scoreSet.scoreConfig.name))
      .catch(ex => this.onErrorSaving(scoreSet, 'saving', () => this.onEditScoreSet(scoreSet))(ex));
  }

  onEditedScoreSet(scoreSet){
    const notification = (<Notification
      text={`Your Scoring Set "${scoreSet.scoreConfig.name}" has successfully been updated.`}
      type={Notification.Types.SUCCESS}

    />);
    notificationService.addPopup(notification);
    var idx = this.state.scoreSets.findIndex(x => x.scoreConfig._id.$oid === scoreSet.scoreConfig._id.$oid)
    if (idx !== -1) {
      this.setState({ // copy new value into arrays
        scoreSets:   this.state.scoreSets.slice(0, idx).concat([scoreSet]).concat(this.state.scoreSets.slice(idx + 1)),
        restoreSets: this.state.restoreSets.slice(0, idx).concat([cloneDeep(scoreSet)]).concat(this.state.restoreSets.slice(idx + 1))
      })
    }
    this.setState({isEditing: false});
  }
  //TODO - max retry count?
  onErrorSaving(scoreSet, type, onAttemptRetry){
    return (ex) => {
      const notification = (<Notification
        text={`There was an error ${type} your Scoring Set "${scoreSet.scoreConfig.name}"`}
        type={Notification.Types.WARNING}
        linkText="Please Try Again"
        onLinkClick={onAttemptRetry}
      />);
      notificationService.addPopup(notification);
    }
  }

  onDeleteScoreSet(scoreSet){
    notificationService.addAlert(
      <Alert
        title="Delete Changes"
        message="You are trying to delete a score configuration, this action can not be undone.  Are you sure?"
        success="Delete"
        onSuccess={() => {
          this.scoreSetActionsBridge
            .deleteScoringConfig(scoreSet)
            .then(() => this.onDeletedScoreSet(scoreSet))
            .catch(() => this.onErrorSaving(scoreSet, 'deleting', () => this.onEditScoreSet(scoreSet)));
        }}
        cancel="Cancel"
        onCancel={() => { }}
      />
    );
  }

  onDeletedScoreSet(scoreSet){
    const notification = (<Notification
      text={`Your Scoring Set "${scoreSet.scoreConfig.name}" has successfully been removed.`}
      type={Notification.Types.SUCCESS}

    />);
    notificationService.addPopup(notification);
  }
  onSentimentSelect(collection, topic){
    collection.push(topic);
    this.setState({...this.state, isEditing: true});
  }

  onRemoveSentimentTopic(topic, collection){
    const topicIndex = collection.indexOf(topic);
    collection.splice(topicIndex, 1);
    this.setState({...this.state, isEditing: true});
  }

  getSelectedScoreSet() {
    const { scoreSets, selectedScoreSetIndex } = this.state;
    return scoreSets[selectedScoreSetIndex];
  }

  selecteScoreSetByName(name) {
    const {scoreSets} = this.state;
    let index = 0;
    for(let i = 0; i < scoreSets.length; i++){
      if(scoreSets[i].scoreConfig.name === name){
        index = i;
        break;
      }
    }
    this.setState({ selectedScoreSetIndex: index });
  }

  /**
   * sticky creates a spacer element. It doesn't know that the sticky header's size is changing
   * and can leave a gap when becoming sticky until the user scrolls.
   * The animation of the header's height lasts one second,
   * so this spams scroll events for the next second to trigger recalculations
   */
  hackRedrawStickyForAnimation() {
    const start = new Date().valueOf();
    const end = start + 1000;
    const recurse = () => {
      window.dispatchEvent(new Event('scroll'));
      if (new Date().valueOf() < end) {
        window.requestAnimationFrame(recurse)
      }
    }
    window.requestAnimationFrame(recurse)
  }

  render(){
    const {
      accounts, locations, requesting, scoreSets, scoreSetsDefaults,
      selectedScoreSetIndex, verticals, labels, toolTips, viewState,
      isEditing
    } = this.state;

    if(this.props.state.settings.loading || !scoreSets){
      return (
        <div className="text-center card-spacer-padding-top">
          <h4>Loading Score Settings</h4><i className="fas fa-spinner fa-spin fa-2x"></i>
        </div>
      );
    }

    const selScoreSet = this.getSelectedScoreSet();
    const components = selScoreSet.scoreConfig.components.map((c, i) => this.drawTopLevelSliders(c, selScoreSet.scoreConfig.components, labels, toolTips, viewState[i]));

    return (
      <StickyContainer key="SocialScoreSettings" style={{height: 'auto'}}>
        <NotificationManager />
        <ModalComponent />
        <Sticky
          className="row"
          >
          {
            ({
               isSticky,
               wasSticky,
               style
             }) => {
              if (isSticky && !wasSticky) this.hackRedrawStickyForAnimation();
              return (
                <div
                  className={`sticky-header ${isSticky ? 'stuck-header' : ''}`}
                     style={{...style}} >
                  <div className="lbv-score-header d-flex flex-row justify-content-between">
                    <ScoreSetsHeader
                      ref={(scoreSetComponent) => this.scoreSetComponent = scoreSetComponent }
                      isStuck={isSticky}
                      requesting={requesting}
                      accounts={accounts}
                      scoreSets={scoreSets}
                      scoreSetsDefaults={scoreSetsDefaults}
                      selectedScoreSetIndex={selectedScoreSetIndex}
                      scoreConfigTemplate={scoreSets[0].scoreConfig}
                      verticals={verticals}
                      onSelectedScoreSetChange={this.onSelectedScoreSetChange}
                      onCreateScoreSet={this.onCreateScoreSet}
                      onEditScoreSet={this.onEditScoreSet}
                      onDeleteScoreSet={this.onDeleteScoreSet}
                    />
                  </div>
                  <div className="card">
                    <div className="card-header">
                      <h2 className="card-title-lg">LBV Score</h2>
                    </div>
                    <div className="card-body" style={{
                      paddingTop: isSticky ? '10px' : '20px',
                      paddingBottom: isSticky ? '0' : '10px',
                      transition: 'padding 500ms'
                    }}>
                      <ScorePreviewSection
                        scoreSet={selScoreSet}
                        isPreviewMode={isEditing || isSticky}
                        locations={locations}
                      />
                    </div>
                    <div className="card-footer">
                      <SaveCancelToolbar
                        onSave={this.onSaveClick}
                        onCancel={this.onResetSettings}
                        onExpandAll={() => this.onExpandAll(true)}
                        onCollapseAll={() => this.onExpandAll(false)}
                        hasChanges={isEditing}
                        isSaving={requesting}
                      />
                    </div>
                  </div>
                </div>
              );
            }
          }
        </Sticky>

        <div className="card card-spacer-top">
          <div className="card-header">
            <h2 className="card-title-lg">
              Settings
            </h2>
            <p className="mb-0">
              Customize your settings and choose what matters to your business most!
            </p>
          </div>
          <div className="card-body card-footerless">
            {components}
          </div>
        </div>
      </StickyContainer>
    );
  }
}

export default withInjector(connect((state, ownProps) => {
  return {
    ...ownProps,
    state
  };
})(SocialScoreSettings))

